import React from 'react'
import LeftBar from '../Components/LeftBar'
import Tabbar from '../Components/Tabbar'

export default function HomeLayout({ children }) {
  return (
    <div className='flex flex-col w-full h-full'>
      <Tabbar />
      <div className='flex w-full h-full overflow-auto'>
        {children}
      </div>

    </div>
  )
}
